// grid component that displays projects as cards
import styles from './styles.module.css';
import React, { useEffect, useRef, useState } from 'react';

import GridItem, { GridItemProps } from './GridItem';
import DropdownWithCheckboxes from '../DropdownWithCheckboxes';

type SequenceGridGamesProps = {
    items: GridItemProps[];
    nrows?: number;
    ncols?: number;
    flatPeriod?: number;
    comingSoonItems?: GridItemProps[];
};

export default function SequenceGridGames({ items, comingSoonItems = [], nrows = 2, ncols = 4, flatPeriod = 2 }: SequenceGridGamesProps) {
    const allTags = Array.from(new Set([...items, ...comingSoonItems].reduce<string[]>((acc, project) => {
        if (project.tags) {
            return [...acc, ...project.tags];
        }
        return acc;
    }, [])));

    const [selectedTags, setSelectedTags] = useState<string[]>(allTags);

    const displayedItems = items.filter(item => {
        if (!item.tags) {
            return true;
        }
        return item.tags.some(tag => selectedTags.includes(tag));
    });

    const displayedComingSoonItems = comingSoonItems.filter(item => {
        if (!item.tags) {
            return true;
        }
        return item.tags.some(tag => selectedTags.includes(tag));
    });

    const displayedItemsJSX = [];
    let row = 1;
    let column = 1;
    let currentFlatPeriod = 0;
    let shouldIncrementRow = true;
    let style: React.CSSProperties = {};
    for (let i = 0; i < displayedItems.length; i++) {
        const index = i;
        const item = displayedItems[index];
        if (currentFlatPeriod !== 0) {
            console.log("increasing column for item", i + 1);
            column += 1;
        } else {
            console.log("not increasing column for item", i + 1);
        }
        displayedItemsJSX.push(<GridItem
            style={style}
            gridRow={row}
            gridColumn={column}
            id={item.id}
            title={item.title}
            key={item.id}
            type={item.type}
            href={item.href}
            contentTags={item.contentTags}
            onClick={item.onClick}
            SvgIcon={item.SvgIcon}
            SvgIconOnHover={item.SvgIconOnHover}
            tags={item.tags}
            isComingSoon={item.isComingSoon}
            beforeNavigationCallback={item.beforeNavigationCallback}
        />)
        if ((row === nrows || row === 1) && index !== 0) {
            currentFlatPeriod++;
            style = {};
            if (currentFlatPeriod === flatPeriod) {
                currentFlatPeriod = 0;
                shouldIncrementRow = !shouldIncrementRow;
                if (shouldIncrementRow) {
                    row += 1;
                } else {
                    row -= 1;
                }
            } else {
                style = {
                    // paddingRight: "20px"
                };
            }
        } else {
            style = {};
            if (shouldIncrementRow) {
                row += 1;
            } else {
                row -= 1;
            }
        }
        column += 1;
    }

    return <>
        <div
            className={`${styles.gridContainer}`}
            style={{
                gridTemplateRows: `repeat(${nrows + 1}, 1fr)`,
                gridTemplateColumns: `repeat(${ncols * 3}, 1fr)`,
            }}
        >
            {displayedItemsJSX}
        </div>
        {displayedComingSoonItems.length > 0 && (
            <div>
                <hr style={{ width: "80%", margin: "0 auto", marginTop: "50px", marginBottom: "50px" }} />
                <h1 style={{ textAlign: "center", fontSize: "2em", marginBottom: "50px" }}>Coming Soon</h1>
                <hr style={{ width: "80%", margin: "0 auto", marginTop: "50px", marginBottom: "50px" }} />
            </div>
        )}
        <div className={`${styles.gridContainer}`}>
            {displayedComingSoonItems.map((project, index) => {
                return (<GridItem
                    gridRow={Math.floor(index / ncols)}
                    gridColumn={index % ncols}
                    id={project.id}
                    title={project.title}
                    key={project.id}
                    type={project.type}
                    href={project.href}
                    contentTags={project.contentTags}
                    onClick={project.onClick}
                    SvgIcon={project.SvgIcon}
                    SvgIconOnHover={project.SvgIconOnHover}
                    tags={project.tags}
                    isComingSoon={project.isComingSoon}
                    beforeNavigationCallback={project.beforeNavigationCallback}
                />);
            })}
        </div>
        {!!allTags.length && <div className={styles.filterByContainer}>
            {/* <DropdownWithCheckboxes items={allTags} onCheckedChange={(checkedTags) => setSelectedTags(checkedTags)} /> */}
        </div>}
    </>;
}
